import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Paginacao } from '../../comum/modelos/paginacao';
import { Evento } from '../../comum/eventos/evento';
import { ComumService } from '../../comum/comum.service';
import { ConfigOcorrenciaAuto } from '../../comum/modelos/config-ocorrencia-auto';
import { OcorrenciasService } from '../ocorrencias.service';
import { ConfirmationService } from 'primeng/primeng';
import { Ocorrencia } from '../../comum/modelos/ocorrencia';
import { Usuario } from '../../comum/modelos/usuario';
import { CookieService } from 'angular2-cookie/core';

@Component({
  selector: 'app-listar-ocorrencias',
  templateUrl: './listar-ocorrencias.component.html',
  styleUrls: ['./listar-ocorrencias.component.css']
})
export class ListarOcorrenciasComponent implements OnInit {
  filtroPesquisaNomePontoFisico: string;
  ocorrencias: Ocorrencia[];
  statusCode: number;
  usuario: Usuario;

  public paginacao: Paginacao;
  public evento: Evento;
  public loading = false;

  constructor(
    private _ocorrenciasService: OcorrenciasService,
    private _comumService: ComumService,
    private confirmationService: ConfirmationService,
    private router: Router,
    private _cookieService: CookieService) {
    this.ocorrencias = new Array<Ocorrencia>();
    this.usuario = new Usuario();
    this.paginacao = new Paginacao();
    this.evento = this._comumService.evento;
    this.loading = false;
    if (this.evento !== undefined) {
      setTimeout(() => {
        this._comumService.cleanEvent();
      }, 2000);
    }
  }

  ngOnInit() {
    this.paginacao.itens = 5;
    this.paginacao.page = 1;
    this.fetchData();
  }

  removerAgendamentoOcorrencia(configOcorrencia: ConfigOcorrenciaAuto): void {
    const self = this;
    this.confirmationService.confirm({
      message: 'Deseja excluir este agendamento?',
      accept: () => {
        this._ocorrenciasService.apagarConfigOcorrenciaAutoHttp(configOcorrencia.idConfigOcorrenciaAuto)
          .subscribe(response => {
            self.statusCode = response.status;
            self._comumService.evento.deletar = true;
            self.ocorrencias = new Array<Ocorrencia>();
            self.fetchData();
            self.router.navigate(['listar-agendamento-ocorrencias']);
            self.loading = false;
            setTimeout(() => {
              self.evento.limparEventos();
            }, 3000);
          }, errorCode => {
            self.statusCode = errorCode;
            self.loading = false;
          });
      },
      reject: () => {
      }
    });
  }

  fetchData() {
    this.loading = true;
    this.usuario = JSON.parse(this._cookieService.get('usuario'));
    this._ocorrenciasService.obterOcorrenciasBaixaUsuario(this.usuario.idUsuario)
      .subscribe((ocorrencias) => {
        this.ocorrencias = ocorrencias;
        this.loading = false;
      });
  }

  pesquisarPorFiltro(filtro: any): void {
    this.filtroPesquisaNomePontoFisico = filtro.value;
  }
}



// WEBPACK FOOTER //
// C:/Development/Projects/Sun/Flag/workspace/flagvarejoang4/src/app/ocorrencias/listar-ocorrencias/listar-ocorrencias.component.ts